import React from 'react';

const NavLink = ({ href, children, className = '', isActive = false }) => {
    return (
        <a
            href={href}
            className={`transition-colors relative ${isActive ? 'text-black font-bold' : 'hover:text-black'} ${className}`}
        >
            {children}
            {isActive && (
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-purple-600 rounded-full"></span>
            )}
        </a>
    );
};

export default NavLink;
